import type { ChatSubagentRun } from "@/lib/chat";
import { formatRunElapsed } from "@/lib/chat-render";
import { useTick } from "@/lib/useTick";

/**
 * run の経過時間。終了済みは endedAt で固定、実行中だけ毎秒の tick を購読して伸ばす。
 * 見るのは開始・終了時刻だけなので、workflow 行にもそのまま使える。
 */
export function SubagentElapsed({ run }: { run: Pick<ChatSubagentRun, "startedAt" | "endedAt"> }) {
	if (run.endedAt !== null) return <>{formatRunElapsed(run.startedAt, run.endedAt, 0)}</>;
	return <RunningElapsed startedAt={run.startedAt} />;
}

function RunningElapsed({ startedAt }: { startedAt: string }) {
	const now = useTick(1_000);
	return <>{formatRunElapsed(startedAt, null, now)}</>;
}
